<template>
  <v-container fluid class="webConLink-management mt-4 px-1">
    <v-row>

      <template>
        <v-row justify="center">
          <v-dialog
              v-model="dialog_upload"
              width="1250px"
          >
            <v-card>

              <UploadManagement
                  id="Conpage_UploadManagement">

              </UploadManagement>

            </v-card>


          </v-dialog>
        </v-row>
      </template>

      <v-col cols="12">
        <v-card class="mb-1" v-if="state=='index'">


          <v-card-title class="pa-5 pb-3">
            <p>การจัดการลิงก์/สื่อ ภายนอก</p><span
              class="grey--text font-weight-regular subtitle-2 pt-1">{{ '\xa0 (' + webConLinks.length }} รายการ) </span>
            <v-spacer></v-spacer>
            <div>

              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="4">

                  <v-select
                      @change="searchData"
                      @blur="changeLinkGroup('s')"
                      v-model="search_data.links_group_tag"
                      :items="link_group_combo"
                      item-text="parameter_th"
                      item-value="parameter_value"
                      label="ประเภทลิงก์"
                      clearable=""
                  ></v-select>


                </v-col>


                <v-col class="d-flex" cols="12" sm="4">

                  <v-select
                      @change="searchData"
                      v-model="search_data.links_type_tag"
                      :items="link_type_combo"
                      item-text="parameter_th"
                      item-value="parameter_value"
                      label="ส่วนแสดงผล"
                      clearable=""
                  ></v-select>


                </v-col>

                <v-col class="d-flex" cols="12" sm="4">
                  <v-text-field
                      append-icon="mdi-magnify"
                      class="search"
                      v-model="search"
                      label="ค้นหา (Search)"
                  ></v-text-field>
                </v-col>

              </v-row>


              <!--              <v-text-field
                                v-model="search"
                                append-icon="mdi-magnify"
                                label="ค้นหา (Search)"
                                single-line
                                hide-details
                                class="search"
                            ></v-text-field>-->
            </div>
          </v-card-title>

          <!--          :footer-props="{
                    'items-per-page-options': [10, 20, 30, 40, 50,-1]
                    }"-->

          <v-card-text class="px-5">
            <v-data-table
                :loading="isReceiving || isDeleting"
                loading-text="Loading... Please wait"
                class="product-table"
                show-select
                :headers="headers"
                :items-per-page="15"
                :footer-props="{
                'items-per-page-options': [5, 10, 15, 50,-1]
                }"
                :items="webConLinks"
                :search="search"
                :options="options">
              <template v-slot:top>


                <template>
                  <v-btn
                      color="success"
                      dark
                      class="my-4 button-shadow"
                      @click="addItem()"
                  >เพิ่มรายการใหม่
                  </v-btn>
                </template>


              </template>

              <template v-slot:item.links_group_tag="{ item }">
                <span>{{ displayLinkText(item.links_group_tag) }}</span>
              </template>


              <template v-slot:item.switch_lang="{ item }">
                <v-btn
                    fab
                    x-small
                    depressed
                    color=""
                >TH
                </v-btn>
                <v-btn v-if="item.switch_lang=='Y'"
                       fab
                       x-small
                       depressed
                       color=""
                >EN
                </v-btn>

              </template>

              <template v-slot:item.links_title_th="{ item }">
                <a :href="item.links_url" target="_blank">
                  <span>{{ item.links_title_th }}</span>
                </a>

              </template>


              <template v-slot:item.active="{ item }">
                <span v-if="item.active == 'Y'" class="v-chip theme--light v-size--small success"><span
                    class="v-chip__content">ใช้งาน</span></span>
                <span v-else class="v-chip theme--light v-size--small "><span
                    class="v-chip__content">ยกเลิก</span></span>


              </template>


              <template v-slot:item.api="{ item }">
                <v-btn
                    class="mr-3 button-shadow"
                    @click="editItem(item)"
                    small
                    color="success"
                >แก้ไข
                </v-btn>
                <v-btn
                    @click="deleteItem(item)"
                    small
                    class="button-shadow"
                    color="secondary"
                >ลบข้อมูล
                </v-btn>
              </template>
            </v-data-table>

          </v-card-text>


        </v-card>

        <v-card class="mb-1" v-if="state=='editForm' || state=='addForm'">

          <v-card-title class="pa-5 pb-3">
            <p>{{ formTitle }}</p>

          </v-card-title>


          <v-card-text class="pa-5 pt-0">
            <v-form
                ref="form"
                v-model="editForm.valid"
                lazy-validation>

              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="2">
                  <v-text-field
                      v-model="editForm.order_seq"
                      label="ลำดับ"
                      required
                      disabled
                      v-if="state=='addForm'"
                  ></v-text-field>

                  <v-text-field
                      v-model="editForm.order_seq"
                      :rules="editForm.textReqRules.concat(editForm.orderRules)"
                      label="ลำดับ"
                      required
                      v-else
                  ></v-text-field>

                </v-col>
                <v-col class="d-flex" cols="12" sm="6">

                  <v-select
                      @change="changeLinkGroup('e')"
                      v-model="editForm.links_group_tag"
                      :rules="editForm.textReqRules"
                      :items="link_group_combo"
                      item-text="parameter_th"
                      item-value="parameter_value"
                      label="ประเภทลิงก์"
                      required
                      clearable=""
                  ></v-select>


                </v-col>


                <v-col class="d-flex" cols="12" sm="3">

                  <v-switch
                      v-model="editForm.switch_lang"
                      inset
                      true-value="Y"
                      false-value="N"
                      :rules="editForm.textReqRules"
                      label="เพิ่มเนื้อหาภาษา [EN]"
                      required
                  ></v-switch>


                </v-col>

              </v-row>

              <v-row align="center">
                <v-col class="d-flex" cols="12" sm="12">

                  <v-select
                      v-model="editForm.links_type_tag"
                      :items="link_type_combo"
                      attach
                      chips
                      deletable-chips
                      item-text="parameter_th"
                      item-value="parameter_value"
                      label="ส่วนแสดงผล"
                      multiple
                      required
                      :rules="editForm.multipleReqRules"
                  ></v-select>


                </v-col>


              </v-row>


              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="12">
                  <v-text-field
                      v-model="editForm.links_title_th"
                      :rules="editForm.textReqRules"
                      label="หัวข้อลิงก์/สื่อ/ชื่อเรื่อง (TH)"
                      required
                  ></v-text-field>
                </v-col>

                <v-col class="d-flex" cols="12" sm="12" v-if="editForm.switch_lang=='Y'">
                  <v-text-field
                      v-model="editForm.links_title_en"
                      :rules="editForm.textReqRules"
                      label="หัวข้อลิงก์/สื่อ/ชื่อเรื่อง (EN)"
                      required
                  ></v-text-field>
                </v-col>

              </v-row>

              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="12">
                  <v-text-field
                      v-model="editForm.links_desc_th"
                      :rules="editForm.textReqRules"
                      :label="editForm.links_group_tag=='D3'?'หน่วยงานที่ดูแล (TH)':'คำอธิบายลิงก์/สื่อ (TH)'"
                      required
                  ></v-text-field>
                </v-col>

                <v-col class="d-flex" cols="12" sm="12" v-if="editForm.switch_lang=='Y'">
                  <v-text-field
                      v-model="editForm.links_desc_en"
                      :rules="editForm.textReqRules"
                      :label="editForm.links_group_tag=='D3'?'หน่วยงานที่ดูแล (EN)':'คำอธิบายลิงก์/สื่อ (EN)'"
                      required
                  ></v-text-field>
                </v-col>

              </v-row>

              <v-row align="center">


                <v-col class="d-flex" cols="12" sm="10">


                  <v-text-field

                      v-model="editForm.links_url"
                      :rules="editForm.textReqRules"
                      label="URL ของลิงก์/สื่อ"
                      hint="โปรดศึกษาวิธีการกรอกข้อมูล URL แต่ละประเภทให้ถูกต้อง"
                      required
                  ></v-text-field>

                </v-col>

                <v-col class="d-flex" cols="12" sm="2">


                  <div class="text-center">
                    <v-btn
                        dark
                        @click="alert = alert==true?false:true"
                    >
                      วิธีระบุ URL
                    </v-btn>
                  </div>
                </v-col>


                <v-alert
                    v-model="alert"
                    border="left"
                    close-text="Close Alert"
                    color="blue-grey"
                    icon="mdi-school"
                    dark
                    width="100%"
                    dismissible
                >
                  1.กรุณากรอก URL เว็บไซต์แบบเต็ม โดยมี http::// หรือ Https:// นำหน้า URL <br>
                  2.ระบบสื่อ รองรับรูปแบบของ Youtube และ Microsoft Stream เท่านั้น
                </v-alert>


              </v-row>

              <v-row align="center" v-if="editForm.links_group_tag=='D3'">


                <v-col class="d-flex" cols="12" sm="10">


                  <v-text-field

                      v-model="editForm.links_url_manual"
                      label="URL คู่มือ (ถ้ามี)"

                  ></v-text-field>

                </v-col>

                <v-col class="d-flex" cols="12" sm="2">


                  <div class="text-center">
                    <v-btn
                        dark
                        @click="showUploads"
                    >
                      <v-icon left>
                        mdi-cloud-upload
                      </v-icon>

                      อัพโหลดไฟล์
                    </v-btn>
                  </div>
                </v-col>




              </v-row>


              <v-row align="center">
                <v-col class="d-flex" cols="12" sm="2">

                  <v-switch
                      v-model="editForm.status_cover"
                      inset
                      true-value="Y"
                      false-value="N"
                      :rules="editForm.textReqRules"
                      label="ไอคอน | อัพโหลดภาพปก"
                      required
                  ></v-switch>

                </v-col>

                <v-col class="d-flex" cols="12" sm="4" v-if="editForm.status_cover=='N'">


                  <v-text-field

                      v-model="editForm.links_h_icon"
                      :rules="editForm.textReqRules"
                      label="รหัสไอคอน Icon"
                      hint="รหัสไอคอน Icon"
                      required
                  >
                    <div
                        slot="append"
                        @click="alert2 = alert2==true?false:true"
                    >
                      <i :class="editForm.links_h_icon" style="font-size: 18pt"></i>
                    </div>

                  </v-text-field>

                </v-col>
                <v-col class="d-flex" cols="12" sm="4" v-if="editForm.status_cover=='N'">


                  <v-text-field

                      v-model="showColor"
                      :rules="editForm.textReqRules"
                      label="รหัสสีพื้นหลัง"
                      hint="เลือก/ระบุ รหัสสีพื้นหลังจากถาดสี"
                      required
                      readonly
                      @click="alert2 = alert2==true?false:true"
                  >
                    <v-icon
                        large
                        slot="append"
                        :color="showColor"
                        @click="alert2 = alert2==true?false:true"
                    >
                      mdi-circle
                    </v-icon>

                  </v-text-field>


                </v-col>

                <v-col class="d-flex" cols="12" sm="2" v-if="editForm.status_cover=='N'">


                  <div class="text-center">
                    <v-btn

                        dark
                        @click="alert2 = alert2==true?false:true"
                    >
                      วิธีระบุ Icons/สีพื้นหลัง
                    </v-btn>
                  </div>
                </v-col>

                <div v-if="editForm.status_cover=='N'">


                  <v-alert
                      v-model="alert2"
                      border="left"
                      close-text="Close Alert"
                      icon="mdi-school"
                      width="100%"
                      dismissible
                  >
                    1. ท่านสามารถระบุ <strong>font awesome</strong> เพื่อระบุ icons สำหรับแสดงเมนูได้ ตัวอย่างเช่น
                    <strong><i class="fab fa-facebook"></i></strong> ระบุเป็น
                    <strong>fab fa-facebook</strong> สามารถดูรหัส icons ทั้งหมดได้ที่ <a
                      href="https://fontawesome.com/v5/search" target="_blank">https://fontawesome.com/v5/search</a>
                    *หมายเหตุ Versions 5.15.4 เท่านั้น
                    <br>
                    2. ท่านสามารถระบุสีพื้นหลังได้จากถาดสีด้านขวา หรือกรอกรหัสสีในรูปแบบ <strong>HEX</strong>
                    <v-container>
                      <v-row>
                        <v-col cols="12" md="6">

                          <v-simple-table>
                            <template v-slot:default>
                              <thead>
                              <tr>
                                <th class="text-left">
                                  ตัวอย่าง icons
                                </th>
                                <th class="text-left">
                                  รหัส
                                </th>

                                <th class="text-left">
                                  ตัวอย่าง icons
                                </th>
                                <th class="text-left">
                                  รหัส
                                </th>
                              </tr>
                              </thead>
                              <tbody>
                              <tr>
                                <td><i class="fab fa-facebook"></i></td>
                                <td>fab fa-facebook</td>
                                <td><i class="fas fa-dollar-sign"></i></td>
                                <td>fas fa-dollar-sign</td>
                              </tr>
                              <tr>
                                <td><i class="fas fa-flask"></i></td>
                                <td>fas fa-flask</td>
                                <td><i class="fas fa-balance-scale"></i></td>
                                <td>fas fa-balance-scale</td>
                              </tr>
                              <tr>
                                <td><i class="fas fa-comments"></i></td>
                                <td>fas fa-comments</td>
                                <td><i class="fas fa-exclamation-triangle"></i></td>
                                <td>fas fa-exclamation-triangle</td>
                              </tr>
                              <tr>
                                <td><i class="fas fa-server"></i></td>
                                <td>fas fa-server</td>
                                <td><i class="fas fa-calendar-day"></i></td>
                                <td>fas fa-calendar-day</td>
                              </tr>
                              <tr>
                                <td><i class="fab fa-internet-explorer"></i></td>
                                <td>fab fa-internet-explorer</td>
                                <td><i class="fas fa-dot-circle"></i></td>
                                <td>fas fa-dot-circle</td>
                              </tr>

                              </tbody>
                            </template>
                          </v-simple-table>


                        </v-col>

                        <v-col cols="12" md="6" class="d-flex justify-center">


                          <v-color-picker v-model="color" mode="hexa">

                          </v-color-picker>

                        </v-col>

                      </v-row>
                    </v-container>


                  </v-alert>

                </div>


                <v-col class="d-flex" cols="12" sm="2" v-if="state=='addForm' && editForm.status_cover=='Y'">

                  <v-col v-if="editForm.preview==''">

                    <v-row
                        class="fill-height"
                        align-content="center"
                        justify="center"
                    >
                      <v-col
                          class="text-subtitle-1 text-center"
                          cols="12"
                      >
                        เลือกไฟล์เพื่อแสดงผล
                      </v-col>
                      <v-col cols="6">
                        <v-progress-linear
                            color="deep-purple accent-4"
                            indeterminate
                            rounded
                            height="6"
                        ></v-progress-linear>
                      </v-col>
                    </v-row>

                  </v-col>
                  <v-col v-else>
                    <img v-bind:src="editForm.preview" style="max-width: 100%"/>
                  </v-col>


                </v-col>

                <v-col class="d-flex" cols="12" sm="3" v-if="state=='addForm' && editForm.status_cover=='Y'">

                  <v-file-input
                      @change="previewImage"
                      v-model="editForm.avatarFile"
                      show-size
                      chips
                      :rules="editForm.textReqRules.concat(editForm.imageRules)"
                      accept="image/*"
                      placeholder="ภาพประกอบ(ปก/อื่นๆ) (TH)"
                      prepend-icon="mdi-file-image"
                      label="ภาพประกอบ(ปก/อื่นๆ) (TH) "
                  ></v-file-input>


                </v-col>

                <v-col class="d-flex" cols="12" sm="2"
                       v-if="state=='addForm' && editForm.switch_lang=='Y' && editForm.status_cover=='Y'">

                  <v-col v-if="editForm.preview_en==''">
                    <v-row
                        class="fill-height"
                        align-content="center"
                        justify="center"
                    >
                      <v-col
                          class="text-subtitle-1 text-center"
                          cols="12"
                      >
                        เลือกไฟล์เพื่อแสดงผล
                      </v-col>
                      <v-col cols="6">
                        <v-progress-linear
                            color="deep-purple accent-4"
                            indeterminate
                            rounded
                            height="6"
                        ></v-progress-linear>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col v-else>
                    <img v-bind:src="editForm.preview_en" style="max-width: 100%"/>
                  </v-col>


                </v-col>

                <v-col class="d-flex" cols="12" sm="3"
                       v-if="state=='addForm' && editForm.switch_lang=='Y' && editForm.status_cover=='Y'">

                  <v-file-input
                      @change="previewImageEn"
                      v-model="editForm.avatarFileEn"
                      show-size
                      chips
                      :rules="editForm.textReqRules.concat(editForm.imageRules)"
                      accept="image/*"
                      placeholder="ภาพประกอบ(ปก/อื่นๆ) (EN)"
                      prepend-icon="mdi-file-image-plus"
                      label="ภาพประกอบ(ปก/อื่นๆ) (EN) "
                  ></v-file-input>


                </v-col>


                <!--*************************************************-->

                <v-col class="d-flex" cols="12" sm="2" v-if="state=='editForm' && editForm.status_cover=='Y'">

                  <v-col v-if="editForm.preview==''">

                    <v-img
                        :src="baseURLStorage+editForm.avatarFileOld"
                        :alt="editForm.links_title_th"
                        style="max-width: 100%"
                    ></v-img>

                  </v-col>
                  <v-col v-else>
                    <img v-bind:src="editForm.preview" style="max-width: 100%"/>
                  </v-col>


                </v-col>

                <v-col class="d-flex" cols="12" sm="3" v-if="state=='editForm' && editForm.status_cover=='Y'">

                  <v-file-input
                      @change="previewImage"
                      v-model="editForm.avatarFile"
                      show-size
                      chips
                      :rules="editForm.imageRules"
                      accept="image/*"
                      placeholder="ภาพประกอบ(ปก/อื่นๆ)ใหม่ (TH)"
                      prepend-icon="mdi-file-image"
                      label="ภาพประกอบ(ปก/อื่นๆ)ใหม่ (TH) "
                  ></v-file-input>


                </v-col>

                <v-col class="d-flex" cols="12" sm="2"
                       v-if="state=='editForm' && editForm.switch_lang=='Y' && editForm.status_cover=='Y'">

                  <v-col v-if="editForm.preview_en==''">
                    <v-img
                        :src="baseURLStorage+editForm.avatarFileEnOld"
                        :alt="editForm.links_title_en"
                        style="max-width: 100%"
                    ></v-img>
                  </v-col>
                  <v-col v-else>
                    <img v-bind:src="editForm.preview_en" style="max-width: 100%"/>
                  </v-col>


                </v-col>

                <v-col class="d-flex" cols="12" sm="3"
                       v-if="state=='editForm' && editForm.switch_lang=='Y' && editForm.status_cover=='Y'">

                  <v-file-input
                      @change="previewImageEn"
                      v-model="editForm.avatarFileEn"
                      show-size
                      chips
                      :rules="editForm.imageRules"
                      accept="image/*"
                      placeholder="ภาพประกอบ(ปก/อื่นๆ)ใหม่ (EN)"
                      prepend-icon="mdi-file-image-plus"
                      label="ภาพประกอบ(ปก/อื่นๆ)ใหม่ (EN) "
                  ></v-file-input>


                </v-col>

                <!--*************************************************-->


              </v-row>


              <v-row align="center">


                <v-col class="d-flex" cols="12" sm="2">

                  <v-switch
                      v-model="editForm.active"
                      inset
                      color="success"
                      true-value="Y"
                      false-value="N"
                      :rules="editForm.textReqRules"
                      label="ใช้งาน"
                      required
                  ></v-switch>


                </v-col>


              </v-row>

              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="12">
                  <v-row justify="end">
                    <v-btn
                        color="secondary"
                        outlined
                        class="button-shadow mr-4"
                        @click="cancelForm">
                      ยกเลิก
                    </v-btn>
                    <v-btn
                        color="primary"
                        outlined
                        class="button-shadow mr-4"
                        @click="reset"
                        v-if="state=='addForm'">
                      ล้างข้อมูล
                    </v-btn>
                    <v-btn
                        :disabled="!editForm.valid"
                        color="primary"
                        class="button-shadow mr-4"
                        @click="validate">
                      บันทึก
                    </v-btn>
                  </v-row>

                </v-col>

              </v-row>

            </v-form>
          </v-card-text>


        </v-card>
      </v-col>
    </v-row>

    <v-snackbar
        v-model="snackbar"
        :color="color"
        right
        top
        style="top: 50px">
      <div v-html="text" class=""></div>
      <template v-slot:action="{ attrs }">
        <v-btn
            dark
            text
            v-bind="attrs"
            @click="snackbar = false">
          ปิด
        </v-btn>
      </template>
    </v-snackbar>

  </v-container>
</template>

<script>
import config from "@/config";
import {mapActions, mapState} from 'vuex';
import validateRules from '@/use/validateRules.js';
import UploadManagement from '@/pages/WebContent/UploadManagement/UploadManagement';
import axios from "axios";


export default {
  name: 'ConLinkManagement',
  data() {
    return {

      types: ['hex'],
      type: 'hex',
      hex: '#1953D2',
      alert: false,//for info input url
      alert2: false,//for info inpot icons-color
      state: 'index',
      tiny: config.tiny,
      baseURLApi: config.baseURLApi,
      baseURLStorage: config.baseURLStorage,
      snackbar: null,
      dialog_upload: false,
      search: '',
      search_data: {
        links_group_tag: "",
        links_type_tag: "",
      },
      options: {
        sortBy: ['order_seq'],
        sortDesc: [true]
      },
      selected: [],
      headers: [
        {
          text: 'ลำดับ',
          align: 'start',
          value: 'order_seq',
        },
        {
          text: 'ประเภท', value: 'links_group_tag',
        },

        {text: 'หลายภาษา', value: 'switch_lang'},
        {text: 'หัวข้อลิงก์/สื่อ/ชื่อเรื่อง', value: 'links_title_th'},
        {text: 'คำอธิบายลิงก์/สื่อ', value: 'links_desc_th'},

        {text: 'ใช้งาน', value: 'active'},
        {text: 'การจัดการ', value: 'api', sortable: false},
      ],
      link_group_combo: [],
      link_type_combo: [],
      detail_combo: [],
      notification: '<p class="font-weight-bold mb-0">หน้าเว็บพร้อมแล้วสำหรับการทำงาน - This page is ready',
      editedIndex: -1,
      editForm: {},
    }
  },
  components: {
    UploadManagement
  },
  computed: {
    // map state ใน Store ของเราเข้ามาเป็น Computed * เข้ามาเป็นตัวแปร
    // Method จะเรียก Function ทุกครั้งที่ Component re-render ใหม่ ซึ่งต่างจาก Computed จะไม่เรียก Function เมื่อ ข้อมูลไม่เปลี่ยน
    ...mapState('web_con_links', ['webConLinks', "isReceiving", "isDeleting", "idToDelete", "webConLinkMessage", "isUpdating", "errorMessage"]),
    formTitle() {
      return this.editedIndex === -1 ? 'เพิ่มรายการใหม่' : 'แก้ไขรายการ'
    },
    color: {
      get() {

        return this[this.type]
      },
      set(v) {
        this[this.type] = v

      },
    },
    showColor() {
      if (typeof this.color === 'string') return this.color

      return JSON.stringify(Object.keys(this.color).reduce((color, key) => {
        color[key] = Number(this.color[key].toFixed(2))
        return color
      }, {}), null, 2)
    },

  },
  watch: {
    //Watched Property  คือ เฝ้าดูว่าข้อมูลในตัวแปลที่เรากําหนดมีการเปลี่ยนแปลงหรือไม่ ถ้ามีการเปลี่ยนแปลงก็จะรันคําสั่งที่เราเขียนไว้

    webConLinkMessage() {

      if (this.webConLinkMessage !== '') {
        this.notification = this.webConLinkMessage

        if (this.errorMessage == true) {
          this.addErrorNotification();
        } else {
          this.addSuccessNotification();
        }
        this.close();
      }
    },

  },
  created() {
    this.addSuccessNotification();
  },
  mounted() {

    //ดึงฟังก์ชั่น จาก store
    this.getWebConLinksRequest(this.search_data);
    this.getDcParamCombobox();
    this.resetValue();

    let recaptchaScript = document.createElement('script')
    recaptchaScript.setAttribute('src', 'https://furcan.github.io/IconPicker/dist/iconpicker-1.5.0.js')
    document.head.appendChild(recaptchaScript)


  },
  methods: {
    // mapAction() เป็น function สําหรับ map action ใน Store ของเราเข้ามาเป็น Methods
    ...mapActions('web_con_links',
        [
          "getWebConLinksRequest",
          "deleteWebConLinkRequest",
          "updateWebConLinkRequest",
          "createWebConLinkRequest"
        ]
    ),
    resetValue() {
      this.alert = false;
      this.alert2 = false;

      this.editForm = {
        valid: true,
        multipleReqRules: validateRules.multipleReqRules,
        orderRules: validateRules.orderRules,
        numRules: validateRules.numRules,
        textReqRules: validateRules.textReqRules,
        imageRules: validateRules.fileSingleRules(3),
        fileRules: validateRules.fileSingleRules(100),
        order_seq: 'AUTO',
        preview: '',
        preview_en: '',
        links_id: null,
        links_type_tag: '',
        links_group_tag: '',
        links_h_icon: 'fas fa-dot-circle',
        links_h_color: '#1976D2FF',
        links_url: '#',
        links_url_manual: '#',
        links_title_th: '',
        links_title_en: '',
        links_desc_th: '',
        links_desc_en: '',
        links_content_th: '',
        links_content_en: '',
        switch_lang: 'N',
        status_cover: 'N',
        active: 'N',
        avatarFile: null,
        avatarFileOld: null,
        avatarFileEn: null,
        avatarFileEnOld: null,
        links_h_image_en: null,
        links_h_image_th: null,

      }
    },
    async getDcParamCombobox() {

      try {

        await axios.post(config.baseURLApi + '/combo_dc_param/' + 'WEB' + '/' + 'LINK_GROUP', '', {
          headers: {},
        }).then(res => {
          this.link_group_combo = res.data;

          this.detail_combo = [];

          for (var i = 0; i < res.data.length; i++) {

            var id = res.data[i].parameter_value

            axios.post(config.baseURLApi + '/combo_dc_param/' + 'WEB' + '/' + 'LINK_TYPE_UNIT_' + id, '', {
              headers: {},
            }).then(res2 => {

              if (res2.data.length > 0) {
                this.detail_combo.push({
                  v_key: res2.data[0].parameter_name.replace("LINK_TYPE_UNIT_", ""),
                  v_value: res2.data,
                })
              }

            });


          }

        });


      } catch (e) {
        this.showSnackbar(e);
      }


    },


    previewImage: function (event) {
      event == null ? this.editForm.preview = '' : this.editForm.preview = URL.createObjectURL(event)
    },
    previewImageEn: function (event) {
      event == null ? this.editForm.preview_en = '' : this.editForm.preview_en = URL.createObjectURL(event)
    },
    addItem() {

      this.editedIndex = -1 //index = -1 add
      this.resetValue();
      this.editForm.links_group_tag = 'D1';
      this.changeLinkGroup('e');
      this.editForm.active = 'Y';
      this.editForm.status_cover = 'N';
      this.editForm.order_seq = 'AUTO';
      this.editForm.links_url = '#';
      this.editForm.links_url_manual = '#';
      this.color = "#4297E8FF";
      this.state = 'addForm';

    },
    editItem(item) {

      // check |null undefined 0 -0 NaN '' false| !X Xis variable return true if null !!x is notnull
      this.resetValue();
      this.editedIndex = this.webConLinks.indexOf(item) //index ของ row ที่จะแก้ไข
      this.editForm.links_id = item.links_id;
      this.editForm.links_group_tag = item.links_group_tag;
      this.changeLinkGroup('e');
      this.editForm.links_type_tag = !item.links_type_tag != true ? item.links_type_tag.split(",") : [];

      this.editForm.avatarFileOld = item.links_h_image_th;
      this.editForm.avatarFileEnOld = item.links_h_image_en;
      this.editForm.links_h_icon = item.links_h_icon;
      this.editForm.links_h_color = item.links_h_color;
      this.color = item.links_h_color;
      this.editForm.links_title_th = item.links_title_th;
      this.editForm.links_title_en = item.links_title_en;
      this.editForm.links_desc_th = item.links_desc_th;
      this.editForm.links_desc_en = item.links_desc_en;
      this.editForm.status_cover = item.status_cover;
      this.editForm.links_url = item.links_url;
      this.editForm.links_url_manual = item.links_url_manual;
      // this.editForm.links_content_th = item.links_content_th;
      // this.editForm.links_content_en = item.links_content_en;
      this.editForm.order_seq = item.order_seq;
      this.editForm.switch_lang = item.switch_lang;
      this.editForm.active = item.active;

      // this.editForm = Object.assign({}, item) //ถ้าใช้ validate not work!!
      this.state = 'editForm';

    },
    deleteItem(item) {

      confirm('ต้องการลบรายการนี้หรือไม่?') && this.deleteWebConLinkRequest({links_id: item.links_id})

    },
    close() {

      if (this.errorMessage == false || this.webConLinkMessage == '') {
        this.state = "index";
        this.editedIndex = -1
      }
    },
    save() {

      this.editForm.links_h_color = this.color;
      if (this.editedIndex > -1) { //> -1 is แก้ไขรายการ else เพิ่มรายการใหม่
        !config.isBackend ?
            Object.assign(this.webConLinks[this.editedIndex], this.editForm)
            :
            this.updateWebConLinkRequest(this.editForm)
      } else {
        !config.isBackend ?
            this.webConLinks.push(this.editForm)
            :
            this.createWebConLinkRequest(this.editForm)
      }


    },
    addSuccessNotification() {
      this.snackbar = true;
      this.color = config.light.success;
      this.text = this.notification;

    },
    addErrorNotification() {
      this.snackbar = true;
      this.color = config.light.secondary;
      this.text = this.notification;
    },


    validate() {
      if (this.$refs.form.validate()) this.save()
    },

    reset() {
      this.$refs.form.reset()
    },
    cancelForm() {
      this.$refs.form.reset()
      // this.close()
      this.state = "index";
      this.editedIndex = -1
    },
    showUploads() {
      this.dialog_upload = true;
    },
    changeLinkGroup(v_form) {
      var links_group_tag = null;
      links_group_tag = v_form == 'e' ? this.editForm.links_group_tag : this.search_data.links_group_tag;

      if (!links_group_tag == false) { //flase is not nall
        this.editForm.links_type_tag = null
        try {
          this.link_type_combo = this.detail_combo.find(item => item.v_key === links_group_tag).v_value
        } catch (e) {
          console.log(e)
          this.link_type_combo = []
        }

      } else {
        this.editForm.links_type_tag = null
        this.link_type_combo = []
      }
    },

    searchData() {
      this.getWebConLinksRequest(this.search_data);
    },
    displayLinkText(item) {

      return !this.link_group_combo.length == true ? '' : (this.link_group_combo.find(combobox => combobox.parameter_value === item)).parameter_th;

    },


    async beforeMount() {
    },

  },
}
</script>

<style src="./ConLinkManagement.scss" lang="scss"/>
<style>
@import 'https://furcan.github.io/IconPicker/dist/fontawesome-5.11.2/css/all.min.css';

</style>